import React from "react";
import ModuleLayout from "../containers/ModuleLayout";

export default class App extends React.Component {
    render() {
        return (
            <ModuleLayout />
        );
    }
}